import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextFieldWrapper } from '../../../../components/Form/MuiFormWrapper';
import DonationContext from '../../../../context/DonationContext/DonationContext';
import { donationManageActions } from '../../../../helpers/donations';

const RequestToDonateNotesStep = () => {
  const { food_donor_notes: donorNotes } = useSelector((state) => state.ui.donation_new.draft);
  const [donorNotesValue, setDonorNotesValue] = useState(donorNotes);

  const { onFieldChange, errors } = useContext(DonationContext);

  return (
    <TextFieldWrapper
      name="food_donor_notes"
      data-testid="food_donor_notes"
      label="Notes for site staff"
      id="food_donor_notes"
      onChange={(event) => setDonorNotesValue(event.target.value)}
      onBlur={(event) => onFieldChange(donationManageActions.set_donor_notes, event.target.value)}
      fullWidth
      value={donorNotesValue}
      variant="outlined"
      size="small"
      multiline
      rows={6}
      helperText={errors.food_donor_notes ? errors.food_donor_notes.message : ''}
    />
  );
};

export default RequestToDonateNotesStep;
